import { render } from "./ComponentBoardItem.vue?vue&type=template&id=ac59a4a8&scoped=true"
import script from "./ComponentBoardItem.vue?vue&type=script&lang=js"
export * from "./ComponentBoardItem.vue?vue&type=script&lang=js"

import "./ComponentBoardItem.vue?vue&type=style&index=0&id=ac59a4a8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ga38som\\IdeaProjects\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac59a4a8"]])

export default __exports__